var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoCrimson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 291.19 291.19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uB808\\uC774\\uC5B4 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uB808\\uC774\\uC5B4 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M232.31 93.25C232.31 35.46 189.62 0 145.59 0S58.88 35.46 58.88 93.25c0 50.65 47.92 101.29 74.69 115.59l-4.29 4.3a9.47 9.47 0 0 0 6.7 16.17h2.09c.86 14.38 10.73 49.2 32.69 61a7.5 7.5 0 0 0 7.09-13.22c-15.32-8.22-23.78-36.61-24.76-47.77h2a9.47 9.47 0 0 0 6.7-16.17l-4.25-4.25c26.74-14.25 74.77-64.9 74.77-115.65zm-61.18-60.34a7.5 7.5 0 0 1 6.47-13.53c11.52 5.51 28.65 21.45 33.46 33.74a7.5 7.5 0 0 1-14 5.47c-3.01-7.78-16.6-21.22-25.93-25.68z",
    fill: "#9b0005"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h291.19v291.19H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCrimson);
export default __webpack_public_path__ + "static/media/logo-crimson.4b95846be8ed781a6eb083e76887bb8b.svg";
export { ForwardRef as ReactComponent };